import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@material-ui/core";
import { Button } from "../../../../components/Wrappers/Wrappers";

// const states = {
//   true: "success",
//   false: "warning",
//   declined: "secondary",
// };
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { sortItems } from "../../../../_helpers";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 1024,
  },
});

function TableComponent(props) {
  let {
    data,
    offset,
    classes,
    handleOpenViewCreateModal,
  } = props;
  let sortedData = {};


  if (data) {
    sortedData = sortItems("asc", "city", data);
  }

  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <Table className="mb-0">
          <TableHead style={{ background: "#f6f6f6" }}>
            <TableRow>
              <TableCell style={{ width: "10%" }}>S. No.</TableCell>
              <TableCell style={{ width: "25%" }}>Address</TableCell>
              <TableCell style={{ width: "15%" }}>City</TableCell>
              <TableCell style={{ width: "15%" }}>Postal/Zip Code</TableCell>
              <TableCell style={{ width: "20%" }}>Province/State</TableCell>
              <TableCell style={{ width: "15%" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((tempdata, index) => (
              <TableRow key={tempdata.id}>
                <TableCell className="pl-3 fw-normal">
                  {offset + index + 1}
                </TableCell>
                <TableCell className="pl-3 fw-normal">
                  {`${tempdata.linecomplete} `}
                </TableCell>
                <TableCell className="pl-3 fw-normal">
                  {tempdata.city}
                </TableCell>

                <TableCell className="pl-3 fw-normal">{tempdata.pin}</TableCell>
                <TableCell className="pl-3 fw-normal">
                  {tempdata.state}
                </TableCell>
                <TableCell style={{ textAlign: "left" }}>
                  <Button
                    color="success"
                    size="small"
                    className="px-2"
                    variant="contained"
                    style={{ marginRight: "5px" }}
                    onClick={() => handleOpenViewCreateModal(tempdata)}
                  >
                    More Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>
        </Table>
      </Table>
    </Paper>
  );
}

export default withStyles(styles)(TableComponent);
